<template>
  <ProyeksiJabatanForm mode="Tambah" module="Proyeksi Jabatan"> </ProyeksiJabatanForm>
</template>

<script>
import ProyeksiJabatanForm from './form';

const ProyeksiJabatanAdd = {
  name: 'ProyeksiJabatanAdd',
  components: { ProyeksiJabatanForm },
};

export default ProyeksiJabatanAdd;
</script>
